module.exports = __webpack_public_path__ + "img/139.10.1a048b8a.png";